import axiosInstance from '../services/AxiosInstance';

export const getKYCSettings = (getData) => {
  return axiosInstance.get("kyc-list/list", {
    params: getData,
  });
};

export const addKYCSetting = (data) => {
  return axiosInstance.post("kyc-list/create", data);
};

export const updateKYCSetting = (id, data) => {
  return axiosInstance.put(`kyc-list/update/${id}`, data);
};

export const fetchKYCSettingById = async (id) => {
    const response = await axiosInstance.get(`kyc-list/show/${id}`);
    return response.data;
};

export const deleteKYCSettingById = async (id) => {
  const response = await axiosInstance.delete(`kyc-list/delete/${id}`);
  return response.data;
};
  
